import { render, staticRenderFns } from "./ek.vue?vue&type=template&id=3a5ae985&scoped=true"
import script from "./ek.vue?vue&type=script&lang=js"
export * from "./ek.vue?vue&type=script&lang=js"
import style0 from "./ek.vue?vue&type=style&index=0&id=3a5ae985&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ae985",
  null
  
)

export default component.exports